export const promiseTimeout = (timeInMilliseconds: number) =>
  new Promise((resolve) => window.setTimeout(() => resolve(timeInMilliseconds), timeInMilliseconds));
